export default __webpack_public_path__ + "static/media/orangeSquiggle.b9748a85.png";